const boolToText = (boolean: boolean): string => (boolean) ? "Yes" : "No";

export default boolToText;
